import React from 'react';
import {observer} from "mobx-react-lite";
import OwlCarousel from 'react-owl-carousel2';
import 'react-owl-carousel2/lib/styles.css';
import 'react-owl-carousel2/src/owl.theme.default.css';
import GameBox from "../../GameBox";

const Slider = ({games}) => {
    const item = {
        items: games.map(game => <GameBox key={game.id} game={game} />)
    };
    const options = {
        loop: true,
        nav: false,
        dots: false,
        center: true,
        responsive: {
            0: {
                items: 1,
                // margin: 24,
                autoWidth: true,
            },
            570: {
                items: 2,
                // margin: 65,
                autoWidth: true,
            },
            768: {
                items: 3,
                // margin: 60,
                autoWidth: true,
            },
            1023: {
                items: 4,
                // margin: 35,
                autoWidth: true,
            }
        }
    };
    return (
        <OwlCarousel options={options} touch-action="pan-y" className="owl-carousel owl-theme" >
            {item.items}
        </OwlCarousel>
    );
};

export default observer(Slider);